/* import __COLOCATED_TEMPLATE__ from './recipient-pill-with-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import templateOnlyComponent from '@ember/component/template-only';
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type Admin from 'embercom/models/admin';

interface RecipientPillWithTooltipSignature {
  Args: {
    type: string;
    icon: InterfaceIconName;
    count: number;
    title: string;
    items: Array<{
      text: string;
      icon?: InterfaceIconName;
      avatar?: Admin;
    }>;
  };
}

const RecipientPillWithTooltipComponent =
  templateOnlyComponent<RecipientPillWithTooltipSignature>();

export default RecipientPillWithTooltipComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::RecipientPillWithTooltip': typeof RecipientPillWithTooltipComponent;
    'reporting/recipient-pill-with-tooltip': typeof RecipientPillWithTooltipComponent;
  }
}
